import React from "react";
import Show from "./Show";
import { cn } from "../helpers";

export default function ErrorMessage({
  isTrue = false,
  message = "Harap periksa kembali data yang anda masukkan, area / kolom bertanda * wajib diisi",
  warning = false,
}) {
  return (
    <Show>
      <Show.When isTrue={isTrue}>
        <div
          className={cn(
            `w-full px-4 py-2 rounded-md`,
            warning ? "bg-yellow-100 text-yellow-600" : "bg-red-100 text-red-600",
          )}
        >
          <p>{message || ""}</p>
        </div>
      </Show.When>
      <Show.Else>
        <></>
      </Show.Else>
    </Show>
  );
}
